export const listMeteringRecords = `
   query listMeteringRecords($filter: MeteringRecordsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listMeteringRecords(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              customerId
              sortKey
              meteringRecordId
              meterId
              meterCode
              periodStart
              periodEnd
              value
              dimensionsHash
              state
              watermark
              inputEventCount
              computedAt
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMeteringRecord = `
   query getMeteringRecord($customerId: ID!, $sortKey: String!) {
       getMeteringRecord(customerId: $customerId, sortKey: $sortKey) {
         customerId
         sortKey
         meteringRecordId
         meterId
         meterCode
         periodStart
         periodEnd
         value
         dimensions
         dimensionsHash
         state
         watermark
         inputEventCount
         computedAt
         recordType
         created
         updated
       }
}`;
